import { FINISH_EXPOSURE_RECALCULATION, START_EXPOSURE_RECALCULATION, RECHECK_PANELS_EXPO } from '../panelsActions';
import { dispatch, state } from '__common/store';
import { reCheckPanelsExposure } from '__common/components/exposure/exposureCheckInsideOfEditor';
import hash from 'object-hash';
import { canUseExposure } from '__common/components/exposure/exposureHelper';
import { isAscender } from '__common/constants/products';

export const launchRecheckPanelExposure = (
  panelsToRecheck: number[],
  roofId: number,
  cb?: Function,
  force?: boolean,
  // Delay (ms) before the exposure recalc + completion callback run in the
  // non-force path. Defaults to 1000ms to preserve the legacy roof-switch
  // behaviour. The Lite autosave path passes a much smaller value: it already
  // waits for the user to go idle (container idle gate) before calling this, so
  // the extra 1s defer here only adds latency between an edit and the persisted
  // BOM refetch — the gap that made Lite BOM lag behind Live BOM.
  deferMs: number = 1000,
) => {
  const currentState = state();
  const {
    projectConfiguration: {
      projectEnvConfig: { building_code },
      productId,
    },
    panels: { panels, exposureRecaluclationHash },
  } = currentState;


  if (!canUseExposure(building_code, productId) || isAscender(productId)) {
    if (cb) {
      cb();
    }
    return;
  }

  const panelsHash = hash(panels);

  if (force) {
    dispatch(START_EXPOSURE_RECALCULATION());
    setTimeout(() => {
      try {
        dispatch(RECHECK_PANELS_EXPO(panelsToRecheck, roofId, productId));
        if (cb) {
          cb();
        }
      } finally {
        if (state().panels.exposureRecalculation) {
          dispatch(FINISH_EXPOSURE_RECALCULATION());
        }
      }
    },         50);
    return;
  }

  if (panelsHash !== exposureRecaluclationHash) {
    dispatch(START_EXPOSURE_RECALCULATION());
    setTimeout(() => {
      try {
        dispatch(RECHECK_PANELS_EXPO(panelsToRecheck, roofId, productId, currentState));
        if (cb) {
          cb();
        }
      } finally {
        if (state().panels.exposureRecalculation) {
          dispatch(FINISH_EXPOSURE_RECALCULATION());
        }
      }
    },         deferMs);
  } else if (cb) {
    cb();
  }
};

export const checkPanelsExposure = (
  panelsOnRoof: panelInState[],
  panelsToRecheck: number[],
  roofId: number,
  stateConfig?: any,
) => {
  const { panels, forceExposureChanged } = reCheckPanelsExposure(
    panelsOnRoof,
    panelsToRecheck,
    roofId,
    stateConfig,
  );
  const recheckedPanelIds = new Set(panelsToRecheck);

  return panels.map(panel => {
    if (forceExposureChanged[panel.id] !== undefined) {
      panel.exposedNeighbour = forceExposureChanged[panel.id];
    } else if (recheckedPanelIds.has(panel.id)) {
      panel.exposedNeighbour = false;
    }
    if (panel.manualExposure === 'NE') {
      panel.exposedNeighbour = false;
    }
    return panel;
  });
};
